import { clamp } from 'es-toolkit';
import type { ProgressBarVariant } from './progress-bar-variants';

/** One part of a stacked bar. */
export interface ProgressBarSegment {
  /** Share of the track as a 0–100 percentage. */
  value: number;
  variant: ProgressBarVariant;
  /** Names the segment on hover. */
  label?: string;
}

/** Each segment's width once negatives are dropped and the total is capped at 100. */
export function stackProgressSegments(
  segments: readonly ProgressBarSegment[]
): ProgressBarSegment[] {
  let used = 0;
  return segments.map(segment => {
    const width = clamp(segment.value, 0, 100 - used);
    used += width;
    return { ...segment, value: width };
  });
}
